import toggleAllUsers from "./toggleAllUsers";
import setAllUsers from "./setAllUsers";

export default {
    toggleAllUsers,
    setAllUsers
}